/**
 * Grid Wishlist Handler
 * Handles custom wishlist functionality for product grid items with variant popup
 * Uses Swym API for wishlist operations
 */
(function() {
  'use strict';

  var activePopup = null;
  var wishlistData = []; // Store full wishlist

  // Get all focusable elements inside a container
  function getFocusableElements(container) {
    var elements = container.querySelectorAll(
      'button:not([disabled]):not([style*="display: none"]):not([style*="display:none"]), ' +
      '[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), ' +
      '[tabindex]:not([tabindex="-1"])'
    );
    return Array.prototype.filter.call(elements, function(el) {
      return el.offsetParent !== null; // visible check
    });
  }

  // Handle keydown for focus trap and Escape inside grid popup
  function handleGridPopupKeydown(e) {
    if (!activePopup) return;

    if (e.key === 'Escape') {
      closePopup();
      return;
    }
    if (e.key !== 'Tab') return;

    var focusable = getFocusableElements(activePopup);
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  // Create popup HTML
  function createPopup(btn) {
    var variants = [];
    try {
      variants = JSON.parse(btn.dataset.variants || '[]');
    } catch (e) {
      console.error('Error parsing variants:', e);
      return null;
    }

    var productId = parseInt(btn.dataset.productId);
    var popupTitleId = 'wishlist-grid-popup-title-' + productId;

    var popup = document.createElement('div');
    popup.className = 'wishlist-variant-popup wishlist-variant-popup--grid';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', popupTitleId);
    popup.innerHTML = 
      '<div class="wishlist-variant-popup__overlay"></div>' +
      '<div class="wishlist-variant-popup__content">' +
        '<button type="button" class="wishlist-variant-popup__close" aria-label="Close">&times;</button>' +
        '<h3 class="wishlist-variant-popup__title" id="' + popupTitleId + '">Add to Wishlist</h3>' +
        '<div class="wishlist-variant-popup__options">' +
          variants.map(function(variant) {
            var isWishlisted = wishlistData.some(function(item) {
              return item.epi === variant.id;
            });
            var hiddenStyle = !variant.available && !isWishlisted ? ' style="display: none;"' : '';
            var wishlistedClass = isWishlisted ? ' wishlisted' : '';
            var soldClass = !variant.available ? ' wishlist-variant-popup__option--sold' : '';
            
            return '<button type="button" class="wishlist-variant-popup__option' + soldClass + wishlistedClass + '" ' +
              'data-variant-id="' + variant.id + '" ' +
              'data-variant-title="' + variant.size + '" ' +
              'data-variant-available="' + variant.available + '"' + hiddenStyle + '>' +
              '<span class="wishlist-variant-popup__option-title">' + variant.size + '</span>' +
              '<span class="wishlist-variant-popup__option-icon">' +
                '<span class="heart-icon heart-icon--outline">' + emptyHeartSVG + '</span>' +
                '<span class="heart-icon heart-icon--full">' + filledHeartSVG + '</span>' +
              '</span>' +
            '</button>';
          }).join('') +
        '</div>' +
      '</div>';

    return popup;
  }

  // SVG icons for heart states (same as PDP)
  var emptyHeartSVG = '<svg aria-hidden="true" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15"/></svg>';
  
  var filledHeartSVG = '<svg aria-hidden="true" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/></svg>';

  // Update main button state based on wishlisted variants
  function updateButtonState(btn) {
    var productId = parseInt(btn.dataset.productId);
    var hasWishlisted = wishlistData.some(function(item) {
      return item.empi === productId;
    });
    
    console.log('updateButtonState called:', { productId: productId, hasWishlisted: hasWishlisted, btn: btn });
    
    // Handle both grid wishlist buttons and FastSimon heart icons
    btn.classList.toggle('swym-added', hasWishlisted);
    btn.classList.toggle('fs-wishlist-added', hasWishlisted);
    btn.classList.toggle('fs-wishlist-active', hasWishlisted);
    
    // FastSimon structure: .fs-heart-icon-wrapper > span > svg
    // Replace the SVG with the correct heart icon
    var spanWrapper = btn.querySelector('span');
    console.log('spanWrapper:', spanWrapper);
    if (spanWrapper) {
      console.log('Setting innerHTML to:', hasWishlisted ? 'FILLED' : 'EMPTY');
      spanWrapper.innerHTML = hasWishlisted ? filledHeartSVG : emptyHeartSVG;
    }
  }

  // Update all button states
  function updateAllButtonStates() {
    var buttons = document.querySelectorAll('.swym-wishlist-custom, .fs-heart-icon-wrapper[data-variants]');
    buttons.forEach(function(btn) {
      updateButtonState(btn);
    });
  }

  // Show popup
  function showPopup(btn) {
    closePopup(); // Close any existing popup
    
    var popup = createPopup(btn);
    if (!popup) return;

    document.body.appendChild(popup);
    activePopup = popup;
    
    // Store reference to the button
    popup.wishlistBtn = btn;

    // Show popup
    setTimeout(function() {
      popup.style.display = 'flex';
      document.body.style.overflow = 'hidden';

      // Move focus to close button inside the popup
      var closeBtnEl = popup.querySelector('.wishlist-variant-popup__close');
      if (closeBtnEl) closeBtnEl.focus();
    }, 10);

    // Add keyboard listener for focus trap and Escape
    document.addEventListener('keydown', handleGridPopupKeydown);

    // Close handlers
    var closeBtn = popup.querySelector('.wishlist-variant-popup__close');
    var overlay = popup.querySelector('.wishlist-variant-popup__overlay');
    
    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', closePopup);

    // Variant click handlers
    var variantOptions = popup.querySelectorAll('.wishlist-variant-popup__option');
    variantOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        var variantId = parseInt(this.dataset.variantId);
        var isWishlisted = this.classList.contains('wishlisted');
        
        if (isWishlisted) {
          removeFromWishlist(variantId, this, btn);
        } else {
          addToWishlist(variantId, this, btn);
        }
      });
    });
  }

  // Close popup
  function closePopup() {
    if (activePopup) {
      var triggerBtn = activePopup.wishlistBtn;
      activePopup.remove();
      activePopup = null;
      document.body.style.overflow = '';

      // Remove keyboard listener
      document.removeEventListener('keydown', handleGridPopupKeydown);

      // Return focus to the button that opened the popup
      if (triggerBtn) triggerBtn.focus();
    }
  }

  // Add to wishlist
  function addToWishlist(variantId, optionEl, btn) {
    if (!window._swat) {
      console.error('Swym not loaded');
      return;
    }

    var productId = parseInt(btn.dataset.productId);
    var productUrl = btn.dataset.productUrl;
    var productTitle = btn.dataset.productTitle;
    var productImage = btn.dataset.productImage;
    var productPrice = parseFloat(btn.dataset.productPrice) || 0;

    var wishlistItem = {
      epi: variantId,
      empi: productId,
      du: productUrl,
      dt: productTitle,
      iu: productImage,
      pr: productPrice
    };

    window._swat.addToWishList(
      wishlistItem,
      function(response) {
        console.log('Added to wishlist:', response);
        wishlistData.push(wishlistItem);
        optionEl.classList.add('wishlisted');
        updateButtonState(btn);
      },
      function(error) {
        console.error('Error adding to wishlist:', error);
      }
    );
  }

  // Remove from wishlist
  function removeFromWishlist(variantId, optionEl, btn) {
    if (!window._swat) return;

    var productId = parseInt(btn.dataset.productId);
    var item = wishlistData.find(function(i) {
      return i.epi === variantId;
    });

    if (item) {
      window._swat.removeFromWishList(
        { empi: item.empi, epi: item.epi },
        function() {
          console.log('Removed from wishlist');
          wishlistData = wishlistData.filter(function(i) {
            return i.epi !== variantId;
          });
          optionEl.classList.remove('wishlisted');
          
          // Hide if unavailable
          var isAvailable = optionEl.dataset.variantAvailable === 'true';
          if (!isAvailable) {
            optionEl.style.display = 'none';
          }
          
          updateButtonState(btn);
        }
      );
    }
  }

  // Initialize custom wishlist buttons
  function initCustomWishlistButtons(swat) {
    // Handle both grid wishlist buttons and FastSimon heart icons
    var buttons = document.querySelectorAll('.swym-wishlist-custom, .fs-heart-icon-wrapper[data-variants]');
    if (!buttons.length) return;

    // Fetch wishlist data
    swat.fetch(function(wishlist) {
      wishlistData = wishlist;
      updateAllButtonStates();
    });

    // Add click handlers
    buttons.forEach(function(btn) {
      if (btn.dataset.initialized) return;
      btn.dataset.initialized = 'true';

      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        showPopup(btn);
      });

      // Keyboard support for non-button elements (div[role="button"])
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          showPopup(btn);
        }
      });
    });
  }

  // Expose function globally for FSHooks to call after setting data attributes
  window.initWishlistButton = function(btn) {
    if (btn.dataset.initialized) return;
    btn.dataset.initialized = 'true';
    
    // Fetch wishlist data before updating button state
    if (window._swat) {
      window._swat.fetch(function(wishlist) {
        wishlistData = wishlist;
        updateButtonState(btn);
      });
    }
    
    // Handler function for both click and touch
    function handleWishlistClick(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Refresh wishlist data before showing popup
      if (window._swat) {
        window._swat.fetch(function(wishlist) {
          wishlistData = wishlist;
          showPopup(btn);
        });
      } else {
        showPopup(btn);
      }
    }
    
    // Add click handler for desktop
    btn.addEventListener('click', handleWishlistClick, true);

    // Keyboard support for non-button elements (div[role="button"])
    btn.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        e.stopPropagation();
        handleWishlistClick(e);
      }
    });
    
    // Add touchend handler for mobile - touchend is more reliable than click on mobile
    btn.addEventListener('touchend', function(e) {
      // Prevent the subsequent click event from firing
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      // Small delay to ensure touch is complete
      setTimeout(function() {
        if (window._swat) {
          window._swat.fetch(function(wishlist) {
            wishlistData = wishlist;
            showPopup(btn);
          });
        } else {
          showPopup(btn);
        }
      }, 10);
    }, { passive: false, capture: true });
  };

  // Initialize when Swym is ready
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(initCustomWishlistButtons);
  
  // Listen for Swym wishlist changes to keep buttons in sync
  // This handles when PDP wishlist or other sources update the wishlist
  window.SwymCallbacks.push(function(swat) {
    if (swat.evtLayer) {
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function() {
        swat.fetch(function(wishlist) {
          wishlistData = wishlist;
          updateAllButtonStates();
        });
      });
      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function() {
        swat.fetch(function(wishlist) {
          wishlistData = wishlist;
          updateAllButtonStates();
        });
      });
    }
  });

})();
